import Model from "@/models/Model";
import Completion from "@/models/Completion";
import User from "@/models/User";

export default class Homework extends Model {
    resource() {
        return "homework";
    }

    formatDateTime(date) {
        let dateFormatted = date.toLocaleDateString("en-GB", {
            year: "numeric",
            month: "long",
            day: "numeric"
        });
        let timeFormatted = date.toLocaleTimeString("en-GB", {
            hour: "2-digit",
            minute: "2-digit"
        });
        return dateFormatted + " " + timeFormatted;
    }

    due_date() {
        if (!this.due_at) {
            return null;
        }
        let date = new Date(this.due_at.date ?? this.due_at);
        return this.formatDateTime(date);
    }

    published_date() {
        if (!this.published_at) {
            return null;
        }
        let date = new Date(this.published_at.date ?? this.published_at);
        return this.formatDateTime(date);
    }

    completions() {
        return this.hasMany(Completion);
    }

    users() {
        return this.hasMany(User);
    }
}
